import React from 'react';
import ReactDOM from 'react-dom';
import CustomerFormButton from './CustomerFormButton.jsx';
import 'bootstrap/dist/css/bootstrap.css';
import OrderForm from './OrderForm.jsx';
import CustomerFormModal from './CustomerFormModal.jsx';
import StockManagerContextProvider from './StockManagerContext.jsx';

if ( document.getElementById('CustomerFormModal') ) {

    ReactDOM.render(<>
        <CustomerFormModal getMethods={methods => window.CustomerForm = methods} />
    </>, document.getElementById('CustomerFormModal'));
    setTimeout(_ => {window.CustomerForm.open();})

}

if ( document.getElementById('OrderForm') ) {

    ReactDOM.render(<>
        <OrderForm getMethods={methods => window.OrderForm = methods} />
    </>, document.getElementById('OrderForm'));
}
